module.exports = __webpack_public_path__ + "img/last_offres.605fac4a.svg";